import PropTypes from 'prop-types';
import cn from '../../../../../utils/cn';
import { get, isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';
import DraftEditorField from '../../../../Form/DraftEditorField/DraftEditorField';
import ExpandableContainer from '../../../ExpandableContainer/ExpandableContainer';
import HoursOfOperation from '../../../HoursOfOperation/HoursOfOperation';
import ContactInformation from '../../../Contact/ContactInformation/ContactInformation';

const ProviderDescription = ({
  className = '',
  provider,
  isInNetworkGroup = true,
  showMore = false,
  intlProvider = {},
}) => {
  const description = get(provider, 'description');

  const {
    email_addresses,
    phone_numbers,
    primary_contact_name,
    website_url,
  } = provider;

  const showContactInfo =
    !isEmpty(email_addresses) ||
    !isEmpty(phone_numbers) ||
    !isEmpty(primary_contact_name) ||
    !isEmpty(website_url);

  const headerText = !isEmpty(intlProvider) ? (
    <FormattedMessage id="Z+Mo8M" description="org-contact-header" defaultMessage="Organization Contact Information">
      {txt => <div>{txt}</div>}
    </FormattedMessage>
  ) : 'Organization Contact Information';

  return (
    <div className={cn('provider-description', className)} >
      <ExpandableContainer
        controlled
        hideToggle
        id="detail-description-expandable"
        isOpen={showMore}
        showGradient={false}
        useFirstChildHeight={!showMore}
      >
        {
          description &&
          <div className={`${showContactInfo ? 'mb-4': ''}`}>
            <DraftEditorField
              hideLabel
              id={`description-${get(provider, 'id')}`}
              label="Description"
              readOnly
              value={description}
              readOnlyClass='text-base'
            />
          </div>
        }

        {
          showContactInfo &&
          <ContactInformation
            email_addresses={email_addresses}
            headerText={headerText}
            isInNetworkGroup={isInNetworkGroup}
            phone_numbers={phone_numbers}
            primary_contact_name={primary_contact_name}
            showMore={showMore}
            website_url={website_url}
          />
        }

        {
          !isEmpty(provider.hours) &&
          <HoursOfOperation
            hours={provider.hours}
            isInNetworkGroup={isInNetworkGroup}
            showAll={showMore}
            showHoursIcon
            showMore={showMore}
            showToggle={showMore}
            intlProvider={intlProvider}
          />
        }
      </ExpandableContainer>
    </div>
  );
};

ProviderDescription.propTypes = {
  className: PropTypes.string,
  showMore: PropTypes.bool,
  provider: PropTypes.object.isRequired,
  isInNetworkGroup: PropTypes.bool,
  intlProvider: PropTypes.object,
};

export default ProviderDescription;
